// src/core/data/redux/profileDetails.ts
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import apiRequestCall from "../../../apiHelper/globalHelper";
import { all_routes } from "../../../router/backendComponents/admin/all_routes";

export interface ProfileState {
  loading: boolean;
  data: Record<string, any> | null;
  error?: string | null;
}

const initialState: ProfileState = {
  loading: false,
  data: null,
  error: null,
};

const backendRoute = all_routes.backend;

// createAsyncThunk to fetch profile
export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const result = await apiRequestCall("post", backendRoute.getProfile);
      if (result?.data?.code === 200) {
        return result.data.data;
      }
      return rejectWithValue(result?.data || { message: "Failed to load" });
    } catch (err: any) {
      return rejectWithValue(err?.message || "Network error");
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile(state) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    // If you want to update profile locally (optimistic), you can add:
    updateProfileLocal(state, action: PayloadAction<Record<string, any>>) {
      state.data = { ...(state.data || {}), ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as any)?.message || (action.error?.message ?? "Error");
      });
  },
});

export const { clearProfile, updateProfileLocal } = profileSlice.actions;
export default profileSlice.reducer;

// selector helpers
export const selectProfile = (state: any) => state.profile?.data;
export const selectProfileLoading = (state: any) => state.profile?.loading;
